import { render, staticRenderFns } from "./sizeInp.vue?vue&type=template&id=07ece3c1&scoped=true&"
import script from "./sizeInp.vue?vue&type=script&lang=js&"
export * from "./sizeInp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ece3c1",
  null
  
)

export default component.exports